import { gridGapInRem, oneColumnBreakpoint, twoColumnsBreakpoint } from "@/components/pages/blogOverview/BlogOverview.page.style";
import { colors } from "@/styles/styleVariables";
import { breakpoints } from "@/utils/breakPoints";

import { css } from "@emotion/react";

export const wrapper = css`
  
`;

export const buttonAndInfoWrapper = css`
  position: relative;
  align-items: center;
  padding: min(5vw, 4.5rem) 0;
`;

export const infoWrapper = css`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  display: flex;
  gap: 3.2rem;
  font-size: 1.4rem;
  font-weight: 500;

  @media screen and (max-width: ${breakpoints.tablet768}px) {
    margin-top: 4rem;
    position: relative;
  }
`;

export const separatorLine = css`
  height: 1px;
  background-color: ${colors.gray["100"]};
`;

export const richtextWrapper = css`
  margin: min(5vw, 4.5rem) auto;
  max-width: 100rem;

  @media screen and (min-width: ${breakpoints.tablet768}px) {
    *:not(img, div, article) {
      max-width: 70%;
      margin: auto;
    }
  } 
`;

export const moreNewsTitle = css`
  margin: min(5vw, 4.5rem) 0 min(3vw, 3rem);
  font-size: clamp(3rem, 7vw, 7.2rem);
  font-weight: 600;
`;

export const articlesGrid = css` 
  display: grid;
  gap: ${gridGapInRem}rem;
  margin-bottom: 20rem;
  grid-template-columns: repeat(3, 1fr);
  
  @media screen and (max-width: ${twoColumnsBreakpoint}px) {
    grid-template-columns: repeat(2, 1fr);    
  }
  @media screen and (max-width: ${oneColumnBreakpoint}px) {
    grid-template-columns: 1fr;
  }
`;

export const article = css`
  display: flex;
  width: 100%;
`;

export const secondArticle = css`
  @media screen and (max-width: ${oneColumnBreakpoint}px) {
    display: none;
  }
`;

export const thirdArticle = css`
  @media screen and (max-width: ${twoColumnsBreakpoint}px) {
    display: none;
  }
`;

